import { useSelector } from "@/core/redux/store";
import { Button } from "@/shared/components/ui/button";
import { Card, CardContent, CardHeader } from "@/shared/components/ui/card";
import { Separator } from "@/shared/components/ui/separator";
import { ArrowUpRight, File } from "lucide-react";
import { useTranslation } from "react-i18next";
import { GetExploreCompletedCount } from "../helper/list-item-helper";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/core/router/routes";
import { getDashboardLink } from "@/shared/utils/link";
import { InboxType } from "@/shared/services/interface/responses/IInboxResponses";

export const CompletedSpecificationInbox = () => {
  const { t } = useTranslation();
  const { selectedInbox } = useSelector((state) => state.inbox);
  const navigate = useNavigate();
  if (!selectedInbox) return null;

  const getProductCount = () => {
    if (
      selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_MATCHED_PRODUCT_COMPLETED
    ) {
      return selectedInbox.metadata?.itemCount ?? 120;
    }
    if (
      selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_USER_AND_COMMENT_COMPLETED
    ) {
      return selectedInbox.metadata?.itemCount ?? 20;
    }
    if (
      selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_LOCAL_PARTNER_SUPPORT_COMPLETED
    ) {
      return selectedInbox.metadata?.itemCount ?? 15;
    }
    if (
      selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_COMPETITIVE_INDEX_COMPLETED
    ) {
      return selectedInbox.metadata?.itemCount ?? 10;
    }
    if (
      selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_PRODUCER_SCORE_COMPLETED
    ) {
      return selectedInbox.metadata?.itemCount ?? 6;
    }
    return 0;
  };
  return (
    <>
      <div
        className="flex flex-col gap-2 p-4 "
        style={{
          backgroundColor: "rgba(244, 244, 245, 0.5)",
          borderRadius: "0px 0px 7.201px 7.201px",
          border: "0.72px solid #E4E4E7",
        }}
      >
        <span className="text-[16px] font-500 text-muted-foreground">
          {t("inbox:voted_product_count")}{" "}
          <span className="text-[16px] font-700 text-zinc-950">
            {selectedInbox.metadata?.itemCount ?? getProductCount()}
          </span>
        </span>
        <Separator />
        <span className="text-[16px] font-500 text-muted-foreground">
          {t("inbox:steps_of_specification")}{" "}
          <span className="text-[16px] font-700 text-zinc-950">
            {t("inbox:completed_step", {
              count: GetExploreCompletedCount(selectedInbox.type),
            })}
          </span>
        </span>
      </div>
      <div className="mt-4">
        <Button variant="default" className="w-full">
          {t("inbox:check_specification")}
        </Button>
      </div>
      <div className="mt-7">
        <span className="text-[14px] font-600 text-[#000]">
          {t("specification-info")}
        </span>
        <Card
          className="shadow-none !p-3 mt-2 relative cursor-pointer"
          onClick={() => {
            navigate(
              getDashboardLink(ROUTES.Dashboard.Specification.Create) +
                `?specificationId=${selectedInbox.metadata.specification.id}`
            );
          }}
        >
          <CardHeader className="p-0 flex flex-row items-center gap-2">
            <File size={17} />
            <span className="text-[14px] font-600 text-zinc-950 -mt-0.5">
              {selectedInbox.metadata.specification.name}
            </span>
          </CardHeader>
          <CardContent className="p-0 flex flex-row items-center gap-2">
            <File size={16} className="opacity-0" />
            <span className="text-[14px] font-500 text-muted-foreground mt-1">
              {t("category")} |{" "}
              {selectedInbox.metadata?.itemCount ?? getProductCount()}{" "}
              {t("page")}
            </span>
          </CardContent>
          <Button
            variant="outline"
            size="icon"
            className="hover:bg-transparent hover:border-none border-none !h-[20px] !w-[20px] absolute right-2 top-1/2 -translate-y-1/2 "
          >
            <ArrowUpRight size={16} />
          </Button>
        </Card>
      </div>
    </>
  );
};
